<template>
	<div>
		<div class="actDiv" title="扣费统计">
			<label>小区</label>
			<a-select style="width:10rem; margin: 0 0.625rem;font-size: 0.6875rem;" v-model="theNeighbor" placeholder="请选择小区"
				 label-in-value option-filter-prop="children"  :filter-option="filterOption" show-search @change="get">
				<a-select-option v-for="(item,index) in neighborList" :key="item.pId" :value="item.pId">
					{{item.neighborName}}
				</a-select-option>
			</a-select>
			<label>结算</label>
			<a-select style="width:9rem; margin: 0 0.625rem;font-size: 0.6875rem;" v-model="theSettle" label-in-value>
				<a-select-option v-for="(item,index) in dateList" :key="item.PID" :value="item.PID">
					{{getTime(item.StartTime)}}
				</a-select-option>
			</a-select>
			<a-select style="width:9rem; margin: 0 0.625rem;font-size: 0.6875rem;" v-model="searchmodel.pre" :filter-option="false" show-search>
				<a-select-option v-for="(item,index) in payList" :value="item.value">{{item.label}}</a-select-option>
			</a-select>
			<a-button size="small" icon="search"   @click="query" style="margin: 0 0.625rem;">查找</a-button>
			<a-button size="small" icon="printer"   @click="print" style="margin: 0 0.625rem;">打印</a-button>
			<a-button size="small" icon="export"   @click="downloadExcel" style="margin: 0 0.625rem;" :loading="exportLoading">导出Excel</a-button>
		</div>	
	</div>
</template>

<script>
	export default{
		data(){
			return {
				neighborList:[],
				theNeighbor:undefined,
				preType:[
					{
					pre:0,
					preName:'后付费'
					},
					{
					pre:1,
					preName:'预付费'
					},
					{
					pre:2,
					preName:'全部'
					},
				],
				dateList:[],
				searchmodel: {
					n_id: 0,
					pre: 1,
					settle_id: null,
				},
			}
		},
		methods:{
			queryNeighbors:function(){
				let url = this.Api.getLastUrl(this.Api.NEIGHBOR_SEARCH_LIST_URL);
				this.Api.fetchPostWithForm(url).then((data)=>{
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.neighborList = result;
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					console.log(error);
				});
			},
			querylistsettled: function() {
				let url = this.Api.getLastUrl(this.Api.STATIS_List_Settle_Log_URL);
				let n_id = this.searchmodel.n_id;
				this.Api.fetchPost(url, {
					n_id,
					n_id
				}).then((data) => {
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if (code == this.Api.HTTP_OK_CODE) {
						this.dateList = result;
					} else {
						this.$message.error(msg);
					}
				}).catch((error) => {
					console.log(error);
				});
			},
			filterOption(input, option) {
				return (option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0);
			},
		},
		created() {
			this.queryNeighbors();
		},
	}
</script>

<style>
</style>
